import React from 'react';
import { useGetAllObsoleteOrgChartHrSimulation } from '../helpers/hooks/simulation';
import NotFound from 'components/Errors/NotFound';
import HistoricalOrgChartHrContext from 'routes/HumanResourcesModule/Simulation/contexts/ObsoleteOrgChartSimulationContext';

type Props = {
    children?: React.ReactNode;
};

const ObsoleteOrgChartSimulationProvider = ({
    children = <></>,
}: Props): React.ReactElement => {
    const {
        data: obsoleteOrgChartHrSimulationData,
        isLoading,
        isError,
    } = useGetAllObsoleteOrgChartHrSimulation();

    if (isError) {
        return <NotFound />;
    }

    return (
        <HistoricalOrgChartHrContext.Provider
            value={{ data: obsoleteOrgChartHrSimulationData ?? {}, isLoading }}
        >
            {children}
        </HistoricalOrgChartHrContext.Provider>
    );
};

export default ObsoleteOrgChartSimulationProvider;
